import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserDetails } from "../../actions/orderActions";
import { Link, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import { ListProducts } from "../../actions/productAction";
import RentOut from "./RentOut";
import { PDFDownloadLink, Document, Page } from "@react-pdf/renderer";
import OrderPdf from "../Print/OrderPdf";
import RentOutOrderPrint from "./RentOutOrderPrint";
import ReturnOrderPrint from "./ReturnOrderPrint";

import { dateFormat, dateFormatting } from "../utils/Utils";
import "./Order.css";
import { toast } from "react-toastify";

export default function Order() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [copied, setCopied] = useState(false);

  const [order, setOrder] = useState();
  console.log(order);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedItems, setEditedItems] = useState([]);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictData, setConflictData] = useState([]);

  const [noteText, setNoteText] = useState("");
  const [notes, setNotes] = useState([]);

  const [showExtendModal, setShowExtendModal] = useState(false);
  const [extendDate, setExtendDate] = useState("");
  const [checkingExtend, setCheckingExtend] = useState(false);

  //   const [isDelivered, setDelivered] = useState(false);
  //   const [isReturn, setIsReturn] = useState(false);
  // console.log(order)
  useEffect(() => {
    getOrder();
    dispatch(ListProducts({ pagination: false }));
  }, [dispatch]);

  useEffect(() => {
    if (order?.orderItems) {
      setEditedItems(JSON.parse(JSON.stringify(order.orderItems)));
    }
  }, [order]);

  console.log("order", order);
  const productList = useSelector((state) => state.productList);
  const { products } = productList;
  console.log(products, "products");

  const getOrder = async () => {
    const res = await Axios.get(`/api/order/${id}`);
    setOrder(res.data);
    setNotes(res.data.notes || []);
  };
  const getProductName = (id) => {
    const product = products?.find((p) => String(p._id) === String(id));

    return product?.name || "⚠️ Deleted Product";
  };

  const setReturn_ = async (orderId, product, stock) => {
    if (window.confirm("Are you sure want to return this item")) {
      const today = new Date();

      const year = today.getFullYear();
      const month = today.getMonth() + 1; // Months are 0-indexed, so add 1
      const day = today.getDate();

      let obj = {
        orderId,
        product,
        stock,
        date: `${year}-${month}-${day}`,
      };
      await Axios.post(`/api/order/return`, obj).then((res) => {
        if (res.data.status === 200) {
          window.location.href = `/order/${orderId}`;
        }
      });

      // let data = {
      //   isReturn,
      //   id,
      // };
      // await Axios.put(`/api/order`, data).then((res) => {});
    }
  };

  const convertToDate = (val) => {
    const date = new Date(parseInt(val));
    const formattedDate = date.toLocaleDateString();
    return formattedDate;
  };

  console.log(order);

  useEffect(() => {
    returnFnc();
  }, []);

  const [afterReturnOrder, setAfterReturnOrder] = useState({});

  let obj = {
    phone: parseInt(order?.user?.phone),
  };

  const returnFnc = async (e) => {
    const { data } = await Axios.post(`/api/order/list`, obj);

    console.log(data.data[0].orderItems);
    setAfterReturnOrder(data.data[0].orderItems);
  };

  const [userDataaaa, setUserDataaaa] = useState({});

  // Correct the userid access
  let userid = order?.user;

  // Fetch user data
  const userDatasss = async () => {
    try {
      if (userid) {
        const { data } = await Axios.get(`/api/user/${userid}`);
        setUserDataaaa(data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // Call the function in a useEffect when 'order' changes
  useEffect(() => {
    if (userid) {
      userDatasss();
    }
  }, [userid]);

  console.log(userDataaaa, "userdata");

  const handleCopy = () => {
    if (userDataaaa?.phone) {
      navigator.clipboard.writeText(userDataaaa.phone);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000); // Hide after 2 seconds
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...editedItems];

    if (field === "product") {
      const selectedProduct = products.find((p) => p._id === value);

      const price = selectedProduct?.offerPrice || 0;
      const days = updated[index].days || 1;
      const qnty = updated[index].qnty || 1;

      updated[index].product = value;
      updated[index].prodPrice = price;
      updated[index].amount = price * days * qnty;
    } else {
      updated[index][field] = value;
    }

    setEditedItems(updated);
  };

  const handleAddProduct = () => {
    const template = editedItems[0] || {};

    const newItem = {
      ...template,
      product: products?.[0]?._id || "",
      startDate: "",
      endDate: "",
      isDelivered: false,
      isReturn: false,
    };

    delete newItem._id;

    setEditedItems([...editedItems, newItem]);
  };

  const handleDeleteProduct = (index) => {
    if (!window.confirm("Remove this product from order?")) return;

    const updated = [...editedItems];
    updated.splice(index, 1);

    setEditedItems(updated);
  };

  const handleSaveEdit = async () => {
    try {
      // 🔍 Check availability for each edited item
      for (const item of editedItems) {
        const res = await Axios.post(`/api/order/check`, {
          product: item.product,
          startDate: item.startDate,
          endDate: item.endDate,
          qnty: item.qnty || 1,
        });

        // ❌ Conflict found
        if (res.data.available === false) {
          if (res.data.blockedBy && res.data.blockedBy.length > 0) {
            setConflictData(res.data.blockedBy);
            setShowConflictModal(true);
          }
          return; // STOP saving
        }
      }

      // ✅ No conflicts → Save
      await Axios.put(`/api/order/${id}/edit-order`, {
        orderItems: editedItems,
      });

      toast.success("Order updated successfully ✅");
      setIsEditMode(false);
      getOrder();
    } catch (error) {
      toast.error("Failed to update order ❌");
    }
  };

  const addNoteHandler = async () => {
    if (!noteText.trim()) return;

    try {
      const { data } = await Axios.post(`/api/order/${id}/note`, {
        text: noteText,
      });

      setNotes(data);
      setNoteText("");
      toast.success("Note added ✅");
    } catch (error) {
      toast.error("Failed to add note ❌");
    }
  };

  const deleteNoteHandler = async (noteId) => {
    try {
      const { data } = await Axios.delete(`/api/order/${id}/note/${noteId}`);

      setNotes(data);
      toast.success("Note deleted 🗑️");
    } catch (error) {
      toast.error("Failed to delete note ❌");
    }
  };

  const handleExtend = async () => {
    // ✅ Validation
    if (!extendDate) {
      toast.error("Please select a new end date.");
      return;
    }

    const startDate = new Date(order.orderItems[0].startDate);
    const selected = new Date(extendDate);

    startDate.setHours(0, 0, 0, 0);
    selected.setHours(0, 0, 0, 0);

    if (selected < startDate) {
      toast.error("End date cannot be before the start date.");
      return;
    }

    try {
      for (const item of order.orderItems) {
        const res = await Axios.post("/api/order/check", {
          product: item.product,
          startDate: item.startDate,
          endDate: extendDate,
          qnty: item.qnty,
          orderId: id,
        });

        if (!res.data.available) {
          setConflictData(res.data.blockedBy);
          setShowConflictModal(true);
          return;
        }
      }

      await Axios.put(`/api/order/${id}/extend-order`, {
        endDate: extendDate,
      });

      toast.success("Order extended successfully");

      setShowExtendModal(false);
      setExtendDate(""); // Clear selected date
      getOrder();
    } catch (err) {
      toast.error("Unable to extend");
    }
  };

  const getNextDate = (date) => {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d.toISOString().split("T")[0];
  };

  const handleExtendDateChange = (e) => {
    const value = e.target.value;

    const startDate = new Date(order.orderItems[0].startDate);
    startDate.setHours(0, 0, 0, 0);

    const selected = new Date(value);
    selected.setHours(0, 0, 0, 0);

    if (selected < startDate) {
      toast.error("End date cannot be before the start date.");
      setExtendDate("");
      return;
    }

    setExtendDate(value);
  };

  const getTimeLeft = (item) => {
    // Not rented out yet
    if (!item?.isDelivered) return "-";

    // Already returned
    if (item?.isReturn) {
      return (
        <span style={{ color: "#198754", fontWeight: "bold" }}>✓ Returned</span>
      );
    }

    const now = new Date();

    const delivered = new Date(item.deliveredAt);

    // add rental days
    const dueDate = new Date(delivered);
    dueDate.setDate(dueDate.getDate() + item.days);
    // Preserve the rent out time
    if (item.deliveredAt) {
      const delivered = new Date(item.deliveredAt);

      dueDate.setHours(
        delivered.getHours(),
        delivered.getMinutes(),
        delivered.getSeconds(),
        0,
      );
    }

    const diff = dueDate.getTime() - now.getTime();

    const totalMinutes = Math.floor(Math.abs(diff) / (1000 * 60));

    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    const text = `${days > 0 ? `${days}d ` : ""}${hours}h ${minutes}m`;

    if (diff >= 0) {
      return (
        <span style={{ color: "green", fontWeight: "bold" }}>
          🟢 {text} left
        </span>
      );
    }

    return (
      <span style={{ color: "red", fontWeight: "bold" }}>
        🔴 {text} overdue
      </span>
    );
  };
  return (
    <>
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="col-md-4 col-xs-12  stretch-card grid-margin">
            <div class="card">
              <div class="card-body">
                <p class="card-title"> ADC_{order?.orderId}</p>
                <ul class="icon-data-list">
                  <li>
                    <div class="d-flex">
                      <div>
                        <small> {dateFormatting(order?.createdAt)}</small>
                        <p class="text-black mb-1 mt-4">
                          Amount : <b> ₹ {order?.orderAmount}</b>
                        </p>
                        <p
                          className="mb-0"
                          style={{ marginLeft: "-15px", fontWeight: "bold" }}
                        >
                          {" "}
                          <Link
                            to={`/user/${order?.user?._id}`}
                            style={{ color: "black" }}
                          >
                            Name : {userDataaaa?.name}
                          </Link>
                        </p>

                        <p className="text-black mb-1 d-flex align-items-center">
                          Phone:{" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            <span> &nbsp;{userDataaaa?.phone}</span>
                          </span>
                          <i
                            className="fa fa-copy ms-2 text-secondary"
                            style={{ cursor: "pointer" }}
                            onClick={handleCopy}
                            title="Copy phone number"
                          ></i>
                        </p>
                        {/* Tooltip */}
                        {copied && (
                          <span
                            style={{
                              position: "absolute",
                              // top: "1px",
                              right: "0",
                              backgroundColor: "#000",
                              color: "#fff",
                              fontSize: "12px",
                              padding: "2px 6px",
                              borderRadius: "4px",
                              opacity: 0.9,
                            }}
                          >
                            Copied!
                          </span>
                        )}
                      </div>
                    </div>
                  </li>
                  {/* <li>
                    <div class="d-flex">
                      {order?.orderItems?.isDelivered === true ? (
                        // <input
                        //   type="checkbox"
                        //   className="form-control"
                        //   style={{ height: '30px', width: '30px' }}
                        //   onChange={(e) => setDelivered(e.target.value)}
                        //   checked={delivered}
                        // />
                        // 'Not'
                        <i
                          className="icon-check menu-icon"
                          style={{ fontSize: '20px' }}
                        ></i>
                      ) : (
                        'Not :'
                        
                      )}
                      <div className="mr-2">
                        <p class="mb-0 ml-2 mt-1">Rent Out</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="d-flex">
                      {order?.orderItems?.isReturn === true ? (
                        <i
                        className="icon-check menu-icon"
                        style={{ fontSize: '20px' }}
                      ></i>
                      ) : (
                        'Not :'

                        
                      )}
                      <div className="mr-2">
                        <p class="mb-0 ml-2 mt-1">Return</p>
                      </div>
                    </div>
                  </li> */}
                </ul>
                <div className="mt-2 align d-flex  justify-content-left">
                  {" "}
                  {order?.isRentOutInit && (
                    <PDFDownloadLink
                      document={
                        <RentOutOrderPrint
                          products={products} // all products
                          customerName={userDataaaa?.name}
                          customerNumber={userDataaaa?.phone}
                          invoiceId={order?.orderId}
                          items={order?.orderItems}
                          address={
                            userDataaaa?.address1 +
                            userDataaaa?.address2 +
                            userDataaaa?.address3
                          }
                          orderDate={order.createdAt}
                          advance={order?.totalReceive}
                          amount={order?.orderAmount}
                          discount={order?.discount}
                          qrCode={order?.qrCode}
                        />
                      }
                      fileName={`${userDataaaa?.name}_Rentout.pdf`}
                    >
                      {({ blob, url, loading, error }) => (
                        <button type="button" class="btn btn-warning">
                          Rentout <i class="fa fa-download ms-2"></i>
                        </button>
                      )}
                    </PDFDownloadLink>
                  )}
                  {order?.isRentOutInit &&
                    order?.orderItems?.some(
                      (item) => item.isReturn === true,
                    ) && (
                      <PDFDownloadLink
                        document={
                          <ReturnOrderPrint
                            products={products} // all products
                            customerNumber={userDataaaa?.phone}
                            customerName={userDataaaa?.name}
                            address={
                              userDataaaa?.address1 +
                              userDataaaa?.address2 +
                              userDataaaa?.address3
                            }
                            invoiceId={order?.orderId}
                            items={order?.orderItems}
                            returnDate={order?.orderItems}
                            returnData={afterReturnOrder}
                            amountDetails={order}
                          />
                        }
                        fileName={`${userDataaaa?.name}_Return.pdf`}
                      >
                        {({ blob, url, loading, error }) => (
                          <button type="button" class="btn btn-success">
                            Return <i class="fa fa-download ms-2"></i>
                          </button>
                        )}
                      </PDFDownloadLink>
                    )}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8  col-xs-12  stretch-card grid-margin">
            <div class="card">
              <div class="card-body">
                <div className="Order-Product-Section d-flex justify-content-between align-items-center">
                  <p class="card-title mb-0">Products</p>

                  <div>
                    {/* Before Rent Out */}
                    {!order?.isRentOutInit &&
                      !order?.orderItems?.every((item) => item.isReturn) &&
                      !isEditMode && (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => setIsEditMode(true)}
                          title="Edit Order"
                        >
                          <i className="fa fa-pen me-1"></i>
                          Edit Order
                        </button>
                      )}

                    {/* After Rent Out */}
                    {order?.isRentOutInit &&
                      !order?.orderItems?.every((item) => item.isReturn) && (
                        <button
                          type="button"
                          className="btn btn-info btn-sm"
                          onClick={() => setShowExtendModal(true)}
                          title="Extend Order"
                        >
                          <i className="fa fa-calendar-plus-o me-1"></i>
                          Extend Order
                        </button>
                      )}

                    {/* Only while editing */}
                    {isEditMode && (
                      <button
                        type="button"
                        className="btn btn-success btn-sm ms-2"
                        onClick={handleAddProduct}
                        title="Add Product"
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    )}
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <thead>
                      <tr>
                        <th className="pl-0 pb-2 border-bottom Order-Col-Index">
                          Index
                        </th>
                        <th className="pl-0 pb-2 border-bottom Order-Col-Name">
                          Name
                        </th>
                        <th className="border-bottom pb-2">Start Date</th>
                        <th className="border-bottom pb-2">End Date</th>
                        <th className="border-bottom pb-2">Time Left</th>
                        <th className="border-bottom pb-2">Rent Out</th>
                        <th className="border-bottom pb-2">Stock</th>
                        <th className="border-bottom pb-2">Return</th>
                        {isEditMode && (
                          <th className="border-bottom pb-2">Action</th>
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {(isEditMode ? editedItems : order?.orderItems)?.map(
                        (data, index) => (
                          <tr key={index}>
                            <td class="text-muted"> {index + 1}.</td>
                            <td class="pl-0">
                              {isEditMode ? (
                                <select
                                  className="form-control Order-Product-Select"
                                  value={data.product}
                                  onChange={(e) =>
                                    handleChange(
                                      index,
                                      "product",
                                      e.target.value,
                                    )
                                  }
                                >
                                  {products?.map((p) => (
                                    <option key={p._id} value={p._id}>
                                      {p.name}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                getProductName(data.product)
                              )}
                            </td>

                            <td>
                              {isEditMode ? (
                                <input
                                  type="date"
                                  className="form-control Order-Product-Date"
                                  value={data.startDate?.slice(0, 10)}
                                  onChange={(e) =>
                                    handleChange(
                                      index,
                                      "startDate",
                                      e.target.value,
                                    )
                                  }
                                />
                              ) : (
                                dateFormatting(data.startDate)
                              )}
                            </td>

                            <td>
                              {isEditMode ? (
                                <input
                                  type="date"
                                  className="form-control Order-Product-Date"
                                  value={data.endDate?.slice(0, 10)}
                                  onChange={(e) =>
                                    handleChange(
                                      index,
                                      "endDate",
                                      e.target.value,
                                    )
                                  }
                                />
                              ) : (
                                dateFormatting(data.endDate)
                              )}
                            </td>

                            <td>{getTimeLeft(data)}</td>

                            <td>
                              <b>
                                {" "}
                                {data?.isDelivered === true ? "YES" : "NO"}
                              </b>{" "}
                              <br />
                              <div className="mt-2">
                                {data?.deliveredAt &&
                                  new Date(data.deliveredAt).toLocaleString(
                                    "en-US",
                                    {
                                      weekday: "short",
                                      month: "short",
                                      day: "2-digit",
                                      year: "numeric",
                                      hour: "numeric",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    },
                                  )}
                              </div>
                              <div></div>
                            </td>
                            <td>
                              <b>
                                {" "}
                                {data?.isDelivered === true ? data?.stock : "-"}
                              </b>{" "}
                            </td>
                            <td>
                              {data?.isDelivered === true ? (
                                data?.isReturn === true ? (
                                  <>
                                    <b>YES</b>
                                    <br />
                                    <div className="mt-2">{data?.returnAt}</div>
                                  </>
                                ) : (
                                  <input
                                    type="checkbox"
                                    className="form-control"
                                    style={{ height: "30px", width: "30px" }}
                                    onChange={(e) =>
                                      setReturn_(id, data?.product, data?.stock)
                                    }
                                    // checked={return_}
                                  />
                                )
                              ) : (
                                "-"
                              )}
                            </td>
                            {isEditMode && (
                              <td>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDeleteProduct(index)}
                                  title="Remove Product"
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </td>
                            )}
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                  {isEditMode && (
                    <div className="Order-Edit-Actions">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={handleSaveEdit}
                      >
                        <i className="fa fa-check"></i>
                      </button>

                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={() => {
                          setEditedItems(order.orderItems);
                          setIsEditMode(false);
                        }}
                      >
                        <i className="fa fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* notes */}
        <div class="col-lg-12 grid-margin stretch-card mt-2">
          <div class="card">
            <div className="card-body">
              <p className="card-title">Notes</p>

              <div className="d-flex mb-3">
                <input
                  type="text"
                  className="form-control mr-2"
                  placeholder="Write a note..."
                  value={noteText}
                  onChange={(e) => setNoteText(e.target.value)}
                />
                <button className="btn btn-primary" onClick={addNoteHandler}>
                  Add
                </button>
              </div>

              {notes.length === 0 ? (
                <p className="text-muted">No notes added.</p>
              ) : (
                notes
                  .slice()
                  .reverse()
                  .map((note) => (
                    <div
                      key={note._id}
                      className="border rounded p-3 mb-2 position-relative"
                      style={{ background: "#f8f9fa" }}
                    >
                      {/* Delete Icon */}
                      <i
                        className="fa fa-trash text-danger"
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "12px",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                        onClick={() => deleteNoteHandler(note._id)}
                        title="Delete note"
                      ></i>

                      <div>{note.text}</div>
                      <small className="text-muted">
                        {note.addedBy || "Admin"} •{" "}
                        {new Date(note.createdAt).toLocaleString()}
                      </small>
                    </div>
                  ))
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <RentOut
        products={order?.orderItems}
        getProductName={getProductName}
        orderId={id}
        isDelivered={isDelivered}
        setDelivered={setDelivered}
        setIsReturn={setIsReturn}
      /> */}

      {showConflictModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 25,
              width: 550,
              maxWidth: "95%",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            }}
          >
            <h4 style={{ marginBottom: 15, color: "#dc3545" }}>
              ❌ Stock Not Available
            </h4>

            <p style={{ marginBottom: 15 }}>
              This product is already booked in the following order(s):
            </p>

            <div className="table-responsive">
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {conflictData.map((item, idx) => (
                    <tr key={idx}>
                      <td>ADC_{item.orderId}</td>
                      <td>{item.customerName || "—"}</td>
                      <td>{item.startDate}</td>
                      <td>{item.endDate}</td>
                      <td>{item.qnty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ textAlign: "right", marginTop: 20 }}>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowConflictModal(false);
                  setConflictData([]);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showExtendModal && (
        <div className="modal fade show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Extend Order</h5>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label>Current End Date</label>

                  <input
                    className="form-control"
                    value={dateFormatting(order.orderItems[0].endDate)}
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label>New End Date</label>

                  <input
                    type="date"
                    className="form-control"
                    value={extendDate}
                    min={order.orderItems[0].startDate.slice(0, 10)}
                    onChange={handleExtendDateChange}
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowExtendModal(false)}
                >
                  Cancel
                </button>

                <button className="btn btn-primary" onClick={handleExtend}>
                  Extend
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
